import { Panels } from "../display/Panels.js";

export class Links {

    public element: HTMLElement;

    constructor() {

        this.element = document.createElement("div");
        this.element.id = "links";
        this.element.classList.add("green-bg");
        document.body.appendChild(this.element);

        for (let panel of Object.values(Panels)) {
            if (panel == Panels.LINKS
                || panel == Panels.ICONS) {
                continue;
            }
            const item = document.createElement("a");
            item.className = "links-item";
            item.href = "?panel=" + panel;
            item.textContent = panel.toUpperCase();
            this.element.appendChild(item);

            const icon = document.createElement("span");
            icon.className = "icon fal fa-chevron-right";
            item.appendChild(icon);
        }
    }
}